import React from "react";
import Text from "../../../../../../shared-components/lexus/styles/atoms/Text";
import List from "../../../styles/atoms/List";
import * as Styles from "./UscBasketItemWrapper.styles";

type PropsType = {
    title: string;
    children: React.ReactNode;
};

const UscBasketItemWrapper = (props: PropsType): JSX.Element => {
    const { title, children } = props;

    return (
        <>
            {!!title.length && (
                <Styles.Wrapper>
                    <Text variant="paragraph-small-regular-uppercase" color="azure">
                        {title}
                    </Text>
                </Styles.Wrapper>
            )}
            <List variant="basket-sub-list" id={`basketlist-${title}`}>
                {children}
            </List>
        </>
    );
};

export default UscBasketItemWrapper;
